export default __webpack_public_path__ + "static/media/screen_2.c55357a9.png";